import React from 'react';

import classnames from 'classnames';

export function Container({className, ...props}){
  return <div className={classnames("w-full px-6 max-w-5xl", className)} {...props}/>
}